import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { AuthGuard, Role } from './modules';
import { PermissionGuard } from './modules/core/auth/guard/permission.guard';
// import { AuthGuard } from './modules/auth';
import { MasterLayoutComponent, SimulationAdminLayoutComponent } from './modules/shared/layouts';

const routes: Routes = [
    {
        path: '',
        component: MasterLayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
            {
                path: '',
                // redirectTo: 'dashboard',
                loadChildren: () => import('./modules/auth/auth-routing.module').then(m => m.AuthRoutingModule),
            },
            {
                path: '',
                // redirectTo: 'dashboard',
                component: SimulationAdminLayoutComponent,
                canActivate: [AuthGuard],
                children: [
                    {
                        path: 'dashboard',
                        // component: SimulationAdminLayoutComponent,
                        loadChildren: () =>
                            import('./modules/dashboard/dashboard-routing.module').then(
                                m => m.DashboardRoutingModule,
                            ),
                    },
                    {
                        path: 'simulations',
                        // component: SimulationAdminLayoutComponent,
                        loadChildren: () =>
                            import('./modules/simulation/simulation-routing.module').then(
                                m => m.SimulationRoutingModule,
                            ),
                    },
                    {
                        path: 'organizations',
                        loadChildren: () =>
                            import('./modules/organizations/organizations.module').then(
                                m => m.OrganizationsModule,
                            ),
                        canActivate: [PermissionGuard],
                        data: {
                            roles: [Role.SUPER_ADMIN, Role.ORG_ADMIN, Role.SIMU_ADMIN],
                        },
                    },
                    {
                        path: 'settings',
                        // component: SimulationAdminLayoutComponent,
                        // canActivate: [AuthGuard],
                        loadChildren: () =>
                            import('./modules/settings/settings-routing.module').then(
                                m => m.SettingsRoutingModule,
                            ),
                    },
                    {
                        path: 'change-password',
                        // component: SimulationAdminLayoutComponent,
                        loadChildren: () =>
                            import('./modules/change-password/change-password-routing.module').then(
                                m => m.ChangePasswordRoutingModule,
                            ),
                    },
                    {
                        path: 'edit-profile',
                        // component: SimulationAdminLayoutComponent,
                        canActivate: [AuthGuard],
                        loadChildren: () =>
                            import('./modules/edit-profile/edit-profile-routing.module').then(
                                m => m.EditProfileRoutingModule,
                            ),
                    },
                    {
                        path: '',
                        // component: SimulationAdminLayoutComponent,
                        loadChildren: () =>
                            import('./modules/admin/admin.module').then(m => m.AdminModule),
                    },
                ],
                // loadChildren: () => import('./modules/auth/auth-routing.module').then(m => m.AuthRoutingModule),
            },
            {
                path: 'simulation-started',
                // component: MasterLayoutComponent,
                // canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./modules/simulation-started/simulation-started-routing.module').then(
                        m => m.SimulationStartedRoutingModule,
                    ),
            },
            {
                path: 'participant',
                loadChildren: () =>
                    import('./modules/participant/participant-routing.module').then(m => m.ParticipantRoutingModule),
            },
        ],
    },

    // { path: '404', component: SignUpComponent },
    // { path: '**' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: QuicklinkStrategy,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
